import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import { resolveDefaultMenuVersion, MenuRolloutInput, MenuVersion } from '@/config/menuRollout';

export interface MenuVersionState {
  menuVersion: MenuVersion;
}

@Module({ namespaced: true, name: 'menuVersion' })
export default class MenuVersionModule extends VuexModule implements MenuVersionState {
  public menuVersion: MenuVersion = 2;

  @Mutation
  public SET_MENU_VERSION(version: MenuVersion) {
    this.menuVersion = version;
  }

  /**
   * Resolve the session's menu version from rollout gating. Deliberately does
   * NOT write localStorage: only an explicit user switch (chooseMenuVersion)
   * persists, otherwise the auto-resolved default would masquerade as a choice
   * and freeze future rollout changes.
   */
  @Action
  public initializeMenuVersion(input: MenuRolloutInput) {
    this.context.commit('SET_MENU_VERSION', resolveDefaultMenuVersion(input));
  }

  /** Explicit user switch via the menu switcher. Persisted; wins over defaults. */
  @Action
  public chooseMenuVersion(version: 2 | 3) {
    localStorage.setItem('menuVersionChoice', version.toString());
    this.context.commit('SET_MENU_VERSION', version);
  }
}
